const CONSTANTS = {
  FOOTER: {
    EV: "\u{1E5A}tam",
    EV_TEXT: `At \u{1E5A}tam, We are driven by a passion for a sustainable 
          future. 
          As pioneers in Electric Mobility Analytics, we are dedicated to crafting innovative 
          solutions that aid manufacturers to build better vehicles faster & please customers better`,
    HOME: "Home",
    ABOUT_US: "About Us",
    CONTACT_US: "Contact Us",
    OUR_SERVICES: "Our Solutions",
    PRODRED: "ProdRed",
    DVT: "DVT",
    PHONE: "+91 7795662015",
    MAIL: "rtam-sales@rtam.ai",
    ADDRESS:
      "3rd floor, #129, 8th cross, 3rd phase, JP Nagar, Bangalore - 560078",
    RIGHTS: "© 2024 Company. ALL RIGHTS RESERVED",
    MARKET_PULSE: "Market Pulse",
  },
  HEADER: {
    HOME: "Home",
    ABOUT_US: "About Us",
    OUR_SERVICES: "Our Solutions",
    CONTACT_US: "Contact Us",
    PROD_RED: "Prod Red",
    DVT: "DVT",
    MARKET_PULSE: "Market Pulse",
  },
  HOME: {
    HOME_MAIN_TEXT1: `At `,
    HOME_MAIN_TEXT2: `\u{1E5A}`,
    HOME_MAIN_TEXT3: `tam, We are driven by a passion for a sustainable future. 
          As pioneers in Electric Mobility Analytics, we are dedicated to crafting innovative 
          solutions that aid manufacturers to build better vehicles faster & please customers better`,
    HOME_ABOUT_US1: `We at`,
    HOME_ABOUT_US2: `\u{1E5A}`,
    HOME_ABOUT_US3: `tam are a team of Software Engineers, Data Scientists & Automotive Industry veterans creating solutions for EV Manufacturers.`,

    HOME_ABOUT_US_VISION: `Our Vision is to aid companies in the EV Ecosystem to solve EV related problems faster`,
    HOME_ABOUT_US_VALUES: {
      FIRST: "Excellence",
      SECOND: "Empathy",
      THIRD: "Empowerment",
      FOURTH: "Empowerment",
    },
    HOME_OFFERING_TEXT1: `\u{1E5A}`,
    HOME_OFFERING_TEXT2: `tam solutions help you speed up identifying what to build, building your vehicle and spotting customer problems`,
    HOME_NEED_HELP_HEADER: `Interested in knowing how EV Analytics can change the way you solve problems?`,
    HOME_NEED_HELP_TEXT: `Let's connect and explore ways we can help you!`,
    HOME_PROD_RED_TEXT:`A connected analytics platform that helps electric vehicle (EV) manufacturers accelerate using a Web console and an App `,
    HOME_DVT_TEXT: ` A platform that helps the manufacturer support customers better using data continually streamed from the running vehicles `,
    HOME_MARKET_PULSE_TEXT:` AI algorithms analyze reviews from web forums, app stores or even custom data stores and give you a categorized summary to help you focus your efforts, or understand your competitors better`,
  },
  ABOUT_US: {
    ABOUT_US_1: `We at `,
    ABOUT_US_2: `\u{1E5A}`,
    ABOUT_US_3: `tam are a team of Software Engineers, Data Scientists & Automotive Industry veterans creating solutions for EV Manufacturers.`,
    ABOUT_COMPANY1: `\u{1E5A}`,
    ABOUT_COMPANY2: `tam is a product offering of NicheSolv and is focussed on solutions for the EV Ecosystem  `,
    ABOUT_RTAM1: `\u{1E5A}`,
    ABOUT_RTAM2: `tam ( or ऋतम् in Devanagari) orginates in Vedic Sanskrit - meaning 'latent or hidden truth' or '(underlying) cosmic order' `,
    ABOUT_RTAM3: `Uncovering insights hidden in the vast bits & bytes of vehicular data streams, and helping our OEM customers accelerate - is the idea that behind the name`,
    OUR_CULTURE: `At Ṛtam, We are driven by a passion for a Sustainable Future. We believe in understanding customer problems, empower them with solutions they can use
                 `,
    VISION: `Our Vision is to aid companies in the EV Ecosystem to solve EV related problems faster`,
    MISSION: `To use data & analytics from vehicles & users, provide that to the Ecosystem stakeholders to help them please their end customers`,
    MOTTO: `Your Data, Our Insights`,
    OUR_TEAM_NAME1: "Natraj Gujran",
    OUR_TEAM_POSITION1: "CEO/CTO",
    OUR_TEAM_DETAIL1: `Natraj has worked in technical leadership positions mostly for 
    companies in the San Francisco Bay area. The experience spans large companies like 
    Xerox Research to startups like Sidestep.com(acquired by Kayak.com). He has a Masters 
    in Software Engineering from Carnegie Mellon University, Pittsburgh and a Bachelors 
    in Electronics Engineering from R V College of Engineering, Bangalore.`,
    OUR_TEAM_NAME2: "Giridhar",
    OUR_TEAM_POSITION2: "Executive Director",
    OUR_TEAM_DETAIL2: `Giridhar's expertise finds convergence in Automotive, IoT, and Data Analytics. He brings expertise from his prior role as CTO at Taabi, a CEAT subsidiary dedicated to providing cutting-edge analytical solutions for aftermarket trucks.
With a diverse career that spans leading roles in major automotive companies such as Varroc, where he served as Product Line Head of Automotive IoT and EMS, and Jaguar Cars in the UK. His academic achievements include a Master's in Automotive Engineering from Coventry University, UK, and PGP in Artificial Intelligence & Machine Learning from The University of Texas at Austin. He has also completed a rigorous business management program from the London School of Economics.
Joshi is a speaker at EV conferences, where he shares his insights on the future of electric vehicles, IoT integration, and data-driven decision-making in the automotive sector.
`,
  },
  CONTACT_US: {
    CONTACT_US_1: `Interested in knowing how EV Analytics can change the way you solve problems?`,
    FORM_TEXT: `Or send a message below`,
    FORM_ADDRESS:
      "129, 3rd Floor, 8th Main, J P Nagar 3rd Phase, Bangalore 560078",
    FORM_PHONE: "+91 7795662015",
    FORM_EMAIL: `rtam-sales@rtam.ai`,
    SEND_MESSAGE: "Send Message",
  },
  PROD_RED: {
    PROD_RED_1: `It's an innovative analytics and management platform 
    specifically designed for electric vehicle (EV) manufacturers. It provides comprehensive support 
    from the initial design phase through to the testing of EVs.`,
    STREAMLINE_DEV: `ProdRed aims to simplify and optimize the entire process 
    of EV development, making it more efficient and data-driven. At EV Analytics We 
    Are Driven By A Passion For A Sustainable Future. As Pioneers In Electric Mobility, We Are Dedicated To 
    Crafting Innovative Solutions That Redefine The Way We Move.`,
    ENHANCE_DESIGN: `Provides comprehensive data analysis from prototype testing, 
    including performance metrics, safety assessments and component selection. At EV 
    Analytics We Are Driven By A Passion For A Sustainable Future. As Pioneers In 
    Electric Mobility, We Are Dedicated To Crafting 
    Innovative Solutions That Redefine The Way We Move.`,
    VEHICLE_ANALYTICS: `Vehicle testing analytics plays a crucial role in the continuous 
    improvement of vehicles, ensuring that they meet safety, performance, and environmental 
    standards. Advanced analytics techniques, including machine learning and artificial 
    intelligence, are applied to extract meaningful insights from complex testing data.`,
    PRODRED_BENEFITS_TEXT: `At EV Analytics We Are Driven By A Passion For A Sustainable Future. 
    As Pioneers In Electric Mobility, We
    Are Dedicated To Crafting Innovative Solutions That Redefine The Way We Move.`,
    VEHICLE_ANALYTICS_1: `key areas where vehicle testing analytics is applied`,
    VEHICLE_ANALYTICS_1_1: "Thermal Management",
    VEHICLE_ANALYTICS_1_2: "Charging Infrastructure Compatibility",
    VEHICLE_ANALYTICS_1_3: "Electric Drive System Validation:",
    VEHICLE_ANALYTICS_1_4: "Battery Performance and Longevity",
    VEHICLE_ANALYTICS_1_5: "Many more",
    TEST_ANALYTICS: `Apply advanced analytics techniques to the data collected during 
    vehicle test rides, manufacturers can make data-driven decisions to enhance the vehicle's 
    performance, safety, and user satisfaction. This iterative process of analysis and 
    optimization contributes to the continuous improvement of vehicles.`,
    TEST_ANALYTICS_1: "Acceleration and Speed Analysis",
    TEST_ANALYTICS_2: "Braking System Performance",
    TEST_ANALYTICS_3: "Suspension and Ride Comfort",
    TEST_ANALYTICS_4: "Motor Performance and Range",
    END_LINE_TESTING: `End-of-line testing for electric vehicles (EVs) is a crucial step 
    in ensuring the quality, safety, and reliability of these advanced vehicles before 
    they leave the manufacturing facility. The testing process is adapted to the unique 
    characteristics and components of electric vehicles.
    key aspects of end-of-line testing`,
    END_LINE_TESTING_1: "key aspects of end-of-line testing",
    END_LINE_TESTING_1_1: "Quality Records",
    END_LINE_TESTING_1_2: "Battery Functionality",
    END_LINE_TESTING_1_3: "Powertrain Testing",
    END_LINE_TESTING_1_4: "Charging Port Functionality",
  },
  DVT: {
    DATA_ANALYTICS_1: {
      KEY: "Usage Pattern Analysis: ",
      VALUE:
        "Insight into how vehicles are used in real-world conditions, allowing for data-driven improvements to vehicle features and functions.",
    },
    DATA_ANALYTICS_2: {
      KEY: "Lifecycle Optimization: ",
      VALUE:
        "From initial design to end-of-life, analytics provide a roadmap for sustainability and cost savings across the vehicle's lifecycle.",
    },
    DATA_ANALYTICS_3: {
      KEY: "Vehicle design optimization: ",
      VALUE:
        "Facilitate enhancing future vehicle designs by utilizing historical data and predicting the performance needs.",
    },
    REALTIME_INSIGHTS_1: {
      KEY: "Range Prediction: ",
      VALUE:
        "Accurate forecasting of vehicle range, taking into account current driving conditions, to prevent range anxiety and optimize trip planning.",
    },
    REALTIME_INSIGHTS_2: {
      KEY: "Operational Tracking: ",
      VALUE:
        "Real-time monitoring of vehicle systems, ensuring peak performance and identifying issues as they arise.",
    },
    REALTIME_INSIGHTS_3: {
      KEY: "Maintenance and safety Alerts: ",
      VALUE:
        "Receive instant alerts for safety issues and maintenance needs to ensure vehicle reliability and protecting against unexpected malfunctions.",
    },
    DVT_MAIN: {
      LINE_1: `It is a sophisticated digital platform that creates a 
      virtual replica, or "Twin," of a physical EV. It captures 
      detailed data across the`,
      LINE_2: ` Vehicle's Lifecycle`,
      LINE_3: `, from design 
      and manufacturing to `,
      LINE_4: `on-road performance`,
      LINE_5: ` and maintenance and facilitates intelligent decision-making.`,
    },
    DVT_BENEFITS_HEADER1: "Transformative ",
    DVT_BENEFITS_HEADER2: "Benefits for All Stakeholders",
    DVT_BENEFITS1: {
      TITLE: "For Manufacturers",
      DESCRIPTION: `Streamlined operations with predictive maintenance schedules, 
      resulting in decreased vehicle downtimes and extended asset life.`,
    },
    DVT_BENEFITS2: {
      TITLE: "For Fleet Managers",
      DESCRIPTION: `Streamlined operations with predictive maintenance schedules, 
      resulting in decreased vehicle downtimes and extended asset life.`,
    },
    DVT_BENEFITS3: {
      TITLE: "For Dealers",
      DESCRIPTION: `Enhanced sales strategies through insights into customer usage 
      patterns and preferred features.`,
    },
    DVT_BENEFITS4: {
      TITLE: "For Customers",
      DESCRIPTION: `Improved driving experience with personalized performance reports 
      and maintenance alerts, contributing to a safer, more reliable ride.`,
    },
    DVT_BENEFITS5: {
      TITLE: "For Service Providers",
      DESCRIPTION: `Efficient inventory management with predictive part replacement
       needs and optimized service scheduling.`,
    },
    DVT_BENEFITS6: {
      TITLE: "For Environmental Impact",
      DESCRIPTION: ` DVT aids in the reduction of carbon footprint by optimizing energy usage 
      and supporting the development of sustainable and efficient vehicle technologies.`,
    },
  },
  MARKET_PULSE: {
    HEADER_TITLE_HIGHLIGHT: "Market",
    HEADER_TITLE: "Pulse",
    HEADER_DESC_1: "What are the users saying? About your product, or other products in your segment?",
    HEADER_DESC_2: "What pain points can you solve that will help you get that edge over your competitors?",
    HEADER_DESC_3: "How has user opinion changed over time?",
    HEADER_DESC_4: "Market Pulse's AI algorithms analyze reviews from web forums, app stores or even custom data stores and gives you a categorized summary to help you focus your efforts",
    WHY_TITLE_HIGHLIGHT: "Why Market",
    WHY_TITLE: "Pulse?",
    WHY_DESC: "Want to have a finger on the pulse of users? Understand what they're saying to be able to take concrete actions to remove pain points or find out what pleases them?",
    WHAT_TITLE_HIGHLIGHT: "What is Market",
    WHAT_TITLE: "Pulse?",
    DASHBOARD_TITLE_HIGHLIGHT: "Dashboards",
    DASHBOARD_TITLE: "connecting distant dots",
    DASHBOARD_LIST_1_TITLE: "Navigation & Filtering - Date Ranges, Categories & Sentiments",
    DASHBOARD_LIST_1_DESC: "An intuitive UI that helps you slice the data across time, categories & sentiments.",
    DASHBOARD_LIST_2_TITLE: "30,000 ft view to Blades of grass",
    DASHBOARD_LIST_2_DESC: "Easily drill down from the High level category view to sub categories to individual reviews in a single screen.",
    AI_TITLE_HIGHLIGHT: "AI-Driven",
    AI_TITLE: "Data Analysis",
    AI_LIST_1_TITLE: "Automated Insights at Scale",
    AI_LIST_1_DESC: "Our AI does the job of bucketing thousands of review comments to top level categories and subcategories. Leadership can hone on the problem areas as voiced by the market.",
    AI_LIST_2_TITLE: "Sentiment Extraction",
    AI_LIST_2_DESC: "A secondary dimension across all the reviews to understand what is upsetting the users, or pleasing them.",
    REVIEW_TITLE_HIGHLIGHT: "Review",
    REVIEW_TITLE: "Gathering",
    REVIEW_LIST_1_TITLE: "Gathering Online Feedback",
    REVIEW_LIST_1_DESC: "We scrape sites regularly: Automotive forums, dealer surveys, social media. We look for mention of product models, parts & features to surface the voice of the customer.",
    REVIEW_LIST_2_TITLE: "DMS, ERP, CRM or Direct Customer Feedback ",
    REVIEW_LIST_2_DESC: "We can connect to Dealer Management Systems(DMS) or ERPs/CRMs that contain service records and customer feedback, and merge that information with the online feedback",
  },
};

export default CONSTANTS;
